import { useMemo } from 'react'

export const useRotatingContent = <T>(items: T[] | undefined, count: number): T[] => {
  return useMemo(() => {
    if (!items || items.length === 0) return []

    const actualCount = Math.min(count, items.length)
    const daysSinceEpoch = Math.floor(Date.now() / (1000 * 60 * 60 * 24))
    const offset = daysSinceEpoch % items.length

    const result: T[] = []
    for (let i = 0; i < actualCount; i++) {
      const item = items[(offset + i) % items.length]
      if (item !== undefined) {
        result.push(item)
      }
    }
    return result
  }, [items, count])
}
